var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-cover-wrap"},[_c('div',{staticClass:"tab-cover"},[_c('Tabs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }